import { render } from "./RemoveMenuModifierItem.vue?vue&type=template&id=1d3c92ec&scoped=true"
import script from "./RemoveMenuModifierItem.vue?vue&type=script&lang=js"
export * from "./RemoveMenuModifierItem.vue?vue&type=script&lang=js"

import "./RemoveMenuModifierItem.vue?vue&type=style&index=0&id=1d3c92ec&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3c92ec"]])

export default __exports__